import {useState} from 'react'

const useConfiguration = () => {
    const [isLoading, setIsLoading] = useState(false)
    const [isSnackbarOpen, setIsSnackbarOpen] = useState({isOpen: false, message: 'Setting is updated', severity: 'success'})
    const [onEditMode, setOnEditMode] = useState(false)

    return {onEditMode, setOnEditMode, isSnackbarOpen, setIsSnackbarOpen, isLoading, setIsLoading}
}

export default useConfiguration